// extracted by mini-css-extract-plugin
export default {"content":"Product_dev_content__nZW18","ref":"Product_dev_ref__0tIJB"};